import LandTaxCalculator from "@/apps/portal/views/tools/land-tax-calculator/LandTaxCalculator.vue";
import Login from "../views/auth/Login.vue";
import RegisterConfirm from "../views/auth/RegisterConfirm.vue";
import RegisterResendConfirmationEmail from "../views/auth/RegisterResendConfirmationEmail.vue";
import CalendarIndex from "../views/calendar/Index.vue";
import CampaignCreate from "../views/campaign/Create.vue";
import CampaignEdit from "../views/campaign/Edit.vue";
import CampaignIndex from "../views/campaign/Index.vue";
import CampaignShow from "../views/campaign/Show.vue";
import ClientCreate from "../views/client/Create.vue";
import ClientIndex from "../views/client/Index.vue";
import ClientShow from "../views/client/Show.vue";
import CommissionIndex from "../views/commission/Index.vue";
import ComparisonIndex from "../views/comparison/Index.vue";
import Dashboard from "../views/Dashboard.vue";
import Documentation from "../views/Documentation.vue";
import FactFindCreate from "../views/fact-find/Create.vue";
import FactFindEdit from "../views/fact-find/Edit.vue";
import FactFindIndex from "../views/fact-find/Index.vue";
import GroupCreate from "../views/group/Create.vue";
import GroupEdit from "../views/group/Edit.vue";
import GroupIndex from "../views/group/Index.vue";
import IdCheckCreate from "../views/id-check/Create.vue";
import IdCheckIndex from "../views/id-check/Index.vue";
import InvitationCreate from "../views/invitation/Create.vue";
import InvitationEdit from "../views/invitation/Edit.vue";
import InvitationIndex from "../views/invitation/Index.vue";
import InvitationShow from "../views/invitation/Show.vue";
import InvoiceIndex from "../views/invoice/Index.vue";
import LeadFactFind from "../views/lead/FactFind.vue";
import LeadIndex from "../views/lead/Index.vue";
import MissedLeadIndex from "../views/missedLead/Index.vue";
import MissedLeadShow from "../views/missedLead/Show.vue";
import OfferCreate from "../views/offer/Create.vue";
import OfferEdit from "../views/offer/Edit.vue";
import OfferIndex from "../views/offer/Index.vue";
import PanelCreate from "../views/panel/Create.vue";
import PanelEdit from "../views/panel/Edit.vue";
import PanelIndex from "../views/panel/Index.vue";
import SearchPackBundleCreate from "../views/search-pack-bundle/Create.vue";
import SearchPackBundleEdit from "../views/search-pack-bundle/Edit.vue";
import SearchPackBundleIndex from "../views/search-pack-bundle/Index.vue";
import SearchPackCreate from "../views/search-pack/Create.vue";
import SearchPackIndex from "../views/search-pack/Index.vue";
import ServiceProviderCreate from "../views/service-provider/Create.vue";
import ServiceProviderEdit from "../views/service-provider/Edit.vue";
import ServiceProviderIndex from "../views/service-provider/Index.vue";
import TeamCreate from "../views/team/Create.vue";
import TeamEdit from "../views/team/Edit.vue";
import TeamIndex from "../views/team/Index.vue";
import EstateAgentComparison from "../views/tools/EstateAgentComparison.vue";
import HealthMonitor from "../views/tools/HealthMonitor.vue";
import JobMonitor from "../views/tools/JobMonitor.vue";
import PostcodeManager from "../views/tools/PostcodeManager.vue";
import UserCreate from "../views/user/Create.vue";
import UserEdit from "../views/user/Edit.vue";
import UserIndex from "../views/user/Index.vue";

const dashboardRoutes = [
	{
		path: "/login",
		name: "login",
		component: Login,
		meta: {
			layout: "Auth",
			setJustLoggedIn: true,
			resetRequested: false,
		},
	},
	{
		path: "/sign-up/confirm/:code?",
		name: "register.confirm",
		component: RegisterConfirm,
		props: true,
		meta: {
			layout: "Auth",
		},
	},
	{
		path: "/sign-up/resend-confirmation-email",
		name: "register.resend-confirmation-email",
		component: RegisterResendConfirmationEmail,
		meta: {
			layout: "Auth",
		},
	},
	{
		path: "/password/reset",
		name: "password.requestToken",
		component: require("../views/auth/RequestPasswordResetToken").default,
		meta: {
			layout: "Auth",
		},
	},
	{
		path: "/password/reset/:token",
		name: "password.reset",
		component: require("../views/auth/ResetPassword").default,
		meta: {
			layout: "Auth",
		},
	},
	{
		path: "/welcome",
		name: "welcome",
		component: () => import("../views/Welcome.vue"),
	},
	{
		path: "/",
		name: "dashboard",
		component: Dashboard,
		meta: {
			name: "Dashboard",
		},
	},
	{
		path: "/clients",
		name: "clients.index",
		component: ClientIndex,
		meta: {
			name: "Clients",
		},
	},
	{
		path: "/clients/create",
		name: "clients.create",
		component: ClientCreate,
	},
	{
		path: "/clients/:client",
		name: "clients.show",
		component: ClientShow,
		params: {
			invoice: null,
		},
	},
	{
		path: "/clients/:client/referrals/:introduction/:service",
		name: "clients.referrals.show",
		component: () => import("../views/client/referral/Show.vue"),
	},
	{
		path: "/products",
		name: "products.index",
		component: () => import("../views/product/Index.vue"),
	},
	{
		path: "/products/create",
		name: "products.create",
		component: () => import("../views/product/Create.vue"),
	},
	{
		path: "/cart",
		name: "cart",
		component: () => import("../views/order/Create.vue"),
	},
	{
		path: "/services",
		name: "services.index",
		component: () => import("../views/service/Index.vue"),
	},
	{
		path: "/clients/:client/id-checks",
		name: "idChecks.create",
		component: IdCheckCreate,
		params: {
			invoice: null,
		},
	},
	{
		path: "/commissions",
		name: "commissions.index",
		component: CommissionIndex,
	},
	{
		path: "/invoices",
		name: "invoices.index",
		component: InvoiceIndex,
	},
	{
		path: "/comparisons",
		name: "comparisons.index",
		component: ComparisonIndex,
	},
	{
		path: "/leads",
		name: "leads.index",
		component: LeadIndex,
		meta: {
			name: "Leads",
		},
	},
	{
		path: "/quotes/create",
		name: "quotes.create",
		component: () => import("../views/quote/Create.vue"),
	},
	{
		path: "/quotes/:quote/edit",
		name: "quotes.edit",
		component: () => import("../views/quote/Edit.vue"),
	},
	{
		path: "/missed-leads",
		name: "missedLeads.index",
		component: MissedLeadIndex,
	},
	{
		path: "/missed-leads/:missedLead",
		name: "missedLeads.show",
		component: MissedLeadShow,
	},
	{
		path: "/id-checks",
		name: "idChecks.index",
		component: IdCheckIndex,
	},
	{
		path: "/search-packs",
		name: "searchPacks.index",
		component: SearchPackIndex,
	},
	{
		path: "/search-packs/create",
		name: "searchPacks.create",
		component: SearchPackCreate,
	},
	{
		path: "/instructions/:instruction/search-packs/create",
		name: "instruction.searchPacks.create",
		component: SearchPackCreate,
	},
	{
		path: "/search-pack-bundles",
		name: "searchPackBundles.index",
		component: SearchPackBundleIndex,
	},
	{
		path: "/search-pack-bundles/create",
		name: "searchPackBundles.create",
		component: SearchPackBundleCreate,
	},
	{
		path: "/search-pack-bundles/:searchPackBundle/edit",
		name: "searchPackBundles.edit",
		component: SearchPackBundleEdit,
	},
	{
		path: "/calendar",
		name: "calendar",
		component: CalendarIndex,
	},
	{
		path: "/leads/:lead/fact-find",
		name: "leads.factFind.update",
		component: LeadFactFind,
	},
	{
		path: "/referrals",
		name: "referrals.index",
		component: () => import("../views/referral/Index.vue"),
		meta: {
			name: "Referrals",
		},
	},
	{
		path: "/referrals/create/:client?",
		name: "referrals.create",
		component: () => import("../views/referral/Create.vue"),
	},
	{
		path: "/groups/create",
		name: "groups.create",
		component: GroupCreate,
	},
	{
		path: "/groups/:group/edit",
		name: "groups.edit",
		component: GroupEdit,
	},
	{
		path: "/groups",
		name: "groups",
		component: GroupIndex,
	},
	{
		path: "/panels/create",
		name: "panels.create",
		component: PanelCreate,
	},
	{
		path: "/panels",
		name: "panels",
		component: PanelIndex,
	},
	{
		path: "/panels/:panel/edit",
		name: "panels.edit",
		component: PanelEdit,
	},
	{
		path: "/service-providers",
		name: "serviceProviders",
		component: ServiceProviderIndex,
		meta: {
			name: "Service Providers",
		},
	},
	{
		path: "/service-providers/create",
		name: "serviceProviders.create",
		component: ServiceProviderCreate,
	},
	{
		path: "/service-providers/:serviceProvider/edit",
		name: "serviceProviders.edit",
		component: ServiceProviderEdit,
	},
	{
		path: "/service-providers/:serviceProvider",
		name: "serviceProviders.show",
		component: () => import("../views/service-provider/Show.vue"),
	},
	{
		path: "/invitations",
		name: "invitations.index",
		component: InvitationIndex,
	},
	{
		path: "/invitations/create",
		name: "invitations.create",
		component: InvitationCreate,
	},
	{
		path: "/invitations/:invitation/edit",
		name: "invitations.edit",
		component: InvitationEdit,
	},
	{
		path: "/invitations/:invitation",
		name: "invitations.show",
		component: InvitationShow,
	},
	{
		path: "/campaigns",
		name: "campaigns",
		component: CampaignIndex,
	},
	{
		path: "/campaigns/create",
		name: "campaigns.create",
		component: CampaignCreate,
	},
	{
		path: "/campaigns/:campaign/edit",
		name: "campaigns.edit",
		component: CampaignEdit,
	},
	{
		path: "/campaigns/:campaign",
		name: "campaigns.show",
		component: CampaignShow,
	},
	{
		path: "/report",
		name: "report",
		component: require("../views/report/Show").default,
	},
	{
		path: "/settings",
		name: "settings",
		component: () => import("../views/settings/Index.vue"),
	},
	{
		path: "/settings/profile",
		name: "settings.profile",
		component: () => import("../views/settings/profile/Index.vue"),
	},
	{
		path: "/settings/teams-and-security",
		name: "settings.teamsAndSecurity",
		component: () => import("../views/settings/teamsAndSecurity/Index.vue"),
	},
	{
		path: "/settings/external-apis",
		name: "settings.externalApis",
		component: () => import("../views/settings/externalApis/Index.vue"),
	},
	{
		path: "/settings/fees",
		name: "settings.fees",
		component: () => import("../views/settings/fees/Index.vue"),
	},
	{
		path: "/settings/services",
		name: "settings.services",
		component: () => import("../views/settings/services/Index.vue"),
	},
	{
		path: "/settings/referrers",
		name: "settings.referrers",
		component: () => import("../views/settings/referrers/Index.vue"),
	},
	{
		path: "/settings/meta-keys",
		name: "settings.metaKeys",
		component: () => import("../views/settings/metaKeys/Index.vue"),
	},
	{
		path: "/fact-finds",
		name: "factFinds.index",
		component: FactFindIndex,
	},
	{
		path: "/fact-finds/create",
		name: "factFinds.create",
		component: FactFindCreate,
	},
	{
		path: "/fact-finds/:factFind/edit",
		name: "factFinds.edit",
		component: FactFindEdit,
	},
	{
		path: "/teams",
		name: "teams.index",
		component: TeamIndex,
	},
	{
		path: "/teams/create",
		name: "teams.create",
		component: TeamCreate,
	},
	{
		path: "/teams/:team/edit",
		name: "teams.edit",
		component: TeamEdit,
	},
	{
		path: "/users",
		name: "users.index",
		component: UserIndex,
	},
	{
		path: "/users/create",
		name: "users.create",
		component: UserCreate,
	},
	{
		path: "/users/:user/edit",
		name: "users.edit",
		component: UserEdit,
	},
	{
		path: "/offers",
		name: "offers.index",
		component: OfferIndex,
	},
	{
		path: "/offers/create",
		name: "offers.create",
		component: OfferCreate,
	},
	{
		path: "/offers/:offer/edit",
		name: "offers.edit",
		component: OfferEdit,
	},
	{
		path: "/tools/estate-agent-comparison",
		name: "tools.estateAgentComparison",
		component: EstateAgentComparison,
	},
	{
		path: "/tools/postcode-manager",
		name: "tools.postcodeManager",
		component: PostcodeManager,
	},
	{
		path: "/tools/land-tax-calculator",
		name: "tools.landTaxCalculator",
		component: LandTaxCalculator,
	},
	{
		path: "/health-monitor",
		name: "healthMonitor",
		component: HealthMonitor,
	},
	{
		path: "/request-log",
		name: "requestLog",
		component: () => import("../views/tools/TheRequestLog.vue"),
	},
	// {
	// 	path: '/tools/postcode-manager/:postcodeGeometry/unlinked',
	// 	name: 'tools.postcodeManager.unlinked',
	// 	component: PostcodeManagerUnlinked,
	// },
	{
		path: "/tools/job-monitor",
		name: "tools.jobMonitor",
		component: JobMonitor,
	},
	{
		path: "/documentation",
		name: "documentation",
		component: Documentation,
		meta: {
			layout: "documentation",
		},
	},
	{
		path: "/documentation/*",
		name: "documentationSection",
		component: Documentation,
		meta: {
			layout: "documentation",
		},
	},
	{
		path: "/integration",
		name: "integration",
		component: () => import("../views/Integration.vue"),
	},
	{
		path: "*",
		component: () => import("../views/errors/Error404.vue"),
		meta: {
			layout: "error",
		},
	},
];

export default dashboardRoutes;
